enum Severity {
  NONE = "NONE",
  NORMAL = "NORMAL",
  LIGHT = "LIGHT",
  SEVERE = "SEVERE",
}

export default Severity;

export function getOrder(severity: Severity) {
  switch (severity) {
    case Severity.NONE:
      return 0;
    case Severity.NORMAL:
      return 1;
    case Severity.LIGHT:
      return 2;
    case Severity.SEVERE:
      return 3;
  }
}
